import { usePageHasUserGuide } from './use-page-has-user-guide'

export const useIsUserGuideViewable = () => usePageHasUserGuide()
